<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-07 11:08:47
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-14 11:18:42
-->
<template>
  <el-form :model="form" label-width="120px" label-position="left" :rules="rules">
    <el-form-item label="二级域名" prop="domain">
      <div>
        <el-input v-model="form.domain" placeholder="请输入二级域名" style="width: 240px" maxlength="20" show-word-limit></el-input>
        <span class="ml-16 mr-18 fz-14 yx-color-text-primary">{{host}}</span>
        <el-button type="text" @click="checkDomain">检测并生成域名地址</el-button>
      </div>
      <p class="yx-color-text-secondary fz-12">仅支持小写英文字母，且最长20字符</p>
    </el-form-item>
    <el-form-item label="域名地址">
      <template>
        <p class="yx-color-danger block" style="display: inline-block;width: 240px" v-if="hasError"><i class="el-icon-error"></i> 生成失败，请稍后重试</p>
        <p class="yx-color-warning block" style="display: inline-block;width: 240px" v-else-if="generating"><i class="el-icon-loading"></i> 正在生成中...</p>
        <p class="yx-color-text-regular block"  style="display: inline-block;width: 240px" v-else>{{domainText}}</p>
      </template>
      <el-button type="text" class="ml-16" @click="copyUrl" v-if="domain && !generating && !hasError">复制地址 </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import {copy} from '@/utils/common';
import {checkDomain} from '@/api/teamManage';
import debounce from 'lodash/debounce';
export default {
  name: 'Domain',
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.form.domain = this.config?.domain?.split('.')[0];
  },
  watch: {
    'config.domain'(val) {
      this.form.domain = val?.split('.')[0];
    }
  },
  data() {
    var validateDomain = (rule, value, callback) => {
      if (!/^[a-z]{1,20}$/.test(value) && value !== '') {
        callback(new Error('域名不符合填写规范，请修改。'));
      } else {
        callback();
      }
    };
    return {
      form: {
        domain: ''
      },
      generating: false,
      hasError: false,
      host: '.vipsaas.com',
      rules: {
        domain: [{
          validator: validateDomain, trigger: ['blur', 'change']
        }]
      }
    }
  },
  computed: {
    domain() {
      return this.config.domain;
    },
    domainText() {
      return this.domain ? `${this.domain}` : '请先输入二级域名';
    }
  },
  methods: {
    copyUrl() {
      copy(`https://${this.domain}`);
      this.$message.success("域名地址复制成功");
    },
    checkDomain: debounce(async function() {
      // 检测是否有填写二级域名
      if(this.checkNoDomain()) {
        return;
      }
      // 检测是否在生成域名中
      if(this.checkGenerating('域名正在生成中，请勿重复操作')) {
        return;
      }
      this.generating = true;
      this.hasError = false;
      const {domain} = this.form;
      try {
        const {code} = await checkDomain({domain});
        // 成功后刷新配置接口，失败展示失败状态
        if(code === 0) {
          this.$emit('refresh');
        } else {
          this.hasError = true;
        }
        this.generating = false;
      } catch (error) {
        // 接口失败处理
        this.generating = false;
        this.hasError = true;
      }
    }, 500),
    checkNoDomain() {
      if(!this.form.domain) {
        this.$message.error('请先输入二级域名');
        return true;
      }
      return false;
    },
    checkGenerating(tip) {
      if(this.generating) {
        this.$message.error(tip);
        return true;
      }
      return false;
    }
  }
}
</script>